import { StatusInterface } from "../StatusInterface";
import { Status } from "../Status";
import Translator from "../../../../../Translation/Translator";

class Failed extends Status implements StatusInterface  {

  public static statusId: number = 3;

  public getName(): string {
    return Translator.trans("page/finance-tab/banktransactions-filestatusfailed");
  }

}

export { Failed }
